var _path, _path2, _path3, _path4, _path5, _linearGradient, _path6, _linearGradient2, _path7, _linearGradient3, _path8, _path9, _linearGradient4, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    viewBox: "0 0 538.584 538.583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h538.584v538.583H0V0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M405.5 467.454L269.29 504.13l-136.212-36.676-31.432-340.525h335.29L405.5 467.454z",
    fill: "#2062af"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M269.289 154.511v320.367l.308.084 110.229-29.682 25.443-290.769h-135.98z",
    fill: "#3c9cd7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M191.985 76.899V56.631h29.571V34.453h-51.749v62.684h51.749V76.899h-29.571zm82.766-20.268h20.674V34.453h-51.754v22.178c6.924 6.924 10.535 10.238 20.549 20.252-5.854 0-20.549.021-20.549.02v20.234h51.754V76.899l-20.674-20.268zm73.352 0h20.673V34.453H317.02v22.178c6.924 6.924 10.537 10.238 20.551 20.252-5.852 0-20.551.021-20.551.02v20.234h51.757V76.899l-20.674-20.268z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M269.168 239.656l-97.49 40.602 3.233 40.199 94.257-40.301 100.265-42.868 4.157-41.122-104.422 43.49z",
    fill: "#fff"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: -825.508,
    y1: 1338.301,
    x2: -825.508,
    y2: 1419.102,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1658.759)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#d1d3d4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M171.677 280.258l3.233 40.199 94.257-40.301v-40.5l-97.49 40.602z",
    fill: "url(#a)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: -724.552,
    y1: 1378.602,
    x2: -724.552,
    y2: 1462.591,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1658.759)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#d1d3d4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M373.59 196.167l-104.422 43.489v40.5l100.265-42.868 4.157-41.121z",
    fill: "url(#b)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: -874.103,
    y1: 1302.263,
    x2: -680.039,
    y2: 1302.263,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1658.759)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8e7e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M171.827 280.258l3.234 40.199 144.625.461-3.235 53.598-47.59 13.398-45.748-11.551-2.772-33.268h-42.508l5.545 64.225 85.945 25.412 85.479-24.951 11.09-127.523H171.827z",
    fill: "url(#c)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M269.168 280.258h-97.49l3.233 40.199 94.257.301v-40.5zm0 107.528l-.462.129-45.742-11.551-2.772-33.268h-42.507l5.544 64.225 85.939 25.412v-44.947z",
    opacity: 0.05
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: -883.032,
    y1: 1442.031,
    x2: -672.341,
    y2: 1442.031,
    gradientTransform: "matrix(1 0 0 -1 1045.93 1658.759)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8e7e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M162.898 196.167H373.59l-4.157 41.122H167.98l-5.082-41.122z",
    fill: "url(#d)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M269.168 196.167h-106.27l5.082 41.122h101.188v-41.122z",
    opacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3);
export default __webpack_public_path__ + "static/media/css3.8fba365c2c5824342874c7a674943eb8.svg";
export { ForwardRef as ReactComponent };